
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";

const STRING_TYPE = {
    alphabets: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    numeric: "0123456789"
};

@Injectable()
export class StringGenerator {
    constructor(private db: AngularFireDatabase) { }

    async generate(path: string): Promise<string> {
        try {
            let ref;
            let isExisting: boolean;
            const type = path === "auto" ? "numeric" : "alphabets";

            const stringType = STRING_TYPE[type].split("");
            const stringLength = type === "numeric" ? 5 : 2;

            do {
                ref = this.buildString(stringType, stringLength);
                isExisting = await this.isExisting(ref, path);
            } while (isExisting);

            this.saveString(ref, path);

            return ref;
        } catch (err) {
            console.log(err);

            return "";
        }
    }

    private buildString(stringType, stringLength): string {

        let ref = "";
        while (ref.length <= stringLength) {
            const charPos = Math.floor(Math.random() * (stringType.length - 1));
            ref += stringType[charPos];
        }

        return ref;
    }

    private async saveString(ref: string, path: string): Promise<boolean> {
        try {
            this.db.object(`/references/${path}/${ref}`).set(true);

            return true;
        } catch (err) {
            console.log(err);

            return false;
        }
    }

    private async isExisting(ref: string, path): Promise<boolean> {
        const result = await new Promise<boolean>(resolve => {
            this.db.object(`/references/${path}/${ref}`)
                .valueChanges().subscribe(generatedString => {
                    resolve(generatedString === true);
                });
        });

        return result;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/string/generator.ts